/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Co_Organizer_HintInputs */

const th_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้รับจะต้องตอบรับก่อนจึงจะร่วมจัดการแข่งขันนี้ได้`)
};

const en_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They will be asked to accept before they can help run this event.`)
};

const ja_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待された方が承認すると、このイベントの運営に参加できます。`)
};

const zh_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他们必须先接受，才能协助管理这项赛事。`)
};

const es_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se le pedirá que acepte antes de poder ayudar a organizar este evento.`)
};

const pt_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pessoa precisará aceitar antes de poder ajudar a organizar este evento.`)
};

const id_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mereka harus menerima sebelum bisa membantu mengelola acara ini.`)
};

const fr_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il devra accepter avant de pouvoir aider à organiser cet événement.`)
};

const tl_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kailangan nilang tumanggap bago sila makatulong sa event na ito.`)
};

const vi_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ phải nhận lời trước khi giúp điều hành sự kiện này.`)
};

const ko_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 이벤트를 함께 운영하려면 먼저 수락해야 합니다.`)
};

const de_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er muss zusagen, bevor er bei diesem Event mithelfen kann.`)
};

const ru_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Он должен принять приглашение, прежде чем сможет помогать с этим событием.`)
};

const tr_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinliği yönetmeye yardım etmeden önce daveti kabul etmeliler.`)
};

const it_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deve accettare prima di poter contribuire a questo evento.`)
};

const pl_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musi przyjąć zaproszenie, zanim pomoże prowadzić to wydarzenie.`)
};

const uk_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Він має прийняти запрошення, перш ніж допомагати з цією подією.`)
};

const hi_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस आयोजन में मदद करने से पहले उन्हें स्वीकार करना होगा।`)
};

const ar_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عليه القبول قبل أن يساعد في إدارة هذه الفعالية.`)
};

const ms_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mereka mesti menerima sebelum boleh membantu mengurus acara ini.`)
};

const bn_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই আয়োজনে সাহায্য করার আগে তাঁকে গ্রহণ করতে হবে।`)
};

const zh_tw2_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他們必須先接受，才能協助管理這項賽事。`)
};

const zh_hk2_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他們必須先接受，才能協助管理這項賽事。`)
};

const ur_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ایونٹ میں مدد سے پہلے انہیں قبول کرنا ہوگا۔`)
};

const fa_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیش از کمک به این رویداد باید بپذیرد.`)
};

const sw_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lazima akubali kabla ya kusaidia kuendesha tukio hili.`)
};

const nl_invite_co_organizer_hint = /** @type {(inputs: Invite_Co_Organizer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hij moet aannemen voordat hij aan dit evenement kan meewerken.`)
};

/**
* | output |
* | --- |
* | "They will be asked to accept before they can help run this event." |
*
* @param {Invite_Co_Organizer_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_co_organizer_hint = /** @type {((inputs?: Invite_Co_Organizer_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Co_Organizer_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_co_organizer_hint(inputs)
	if (locale === "ja") return ja_invite_co_organizer_hint(inputs)
	if (locale === "zh") return zh_invite_co_organizer_hint(inputs)
	if (locale === "es") return es_invite_co_organizer_hint(inputs)
	if (locale === "pt") return pt_invite_co_organizer_hint(inputs)
	if (locale === "id") return id_invite_co_organizer_hint(inputs)
	if (locale === "fr") return fr_invite_co_organizer_hint(inputs)
	if (locale === "tl") return tl_invite_co_organizer_hint(inputs)
	if (locale === "vi") return vi_invite_co_organizer_hint(inputs)
	if (locale === "ko") return ko_invite_co_organizer_hint(inputs)
	if (locale === "de") return de_invite_co_organizer_hint(inputs)
	if (locale === "ru") return ru_invite_co_organizer_hint(inputs)
	if (locale === "tr") return tr_invite_co_organizer_hint(inputs)
	if (locale === "it") return it_invite_co_organizer_hint(inputs)
	if (locale === "pl") return pl_invite_co_organizer_hint(inputs)
	if (locale === "uk") return uk_invite_co_organizer_hint(inputs)
	if (locale === "hi") return hi_invite_co_organizer_hint(inputs)
	if (locale === "ar") return ar_invite_co_organizer_hint(inputs)
	if (locale === "ms") return ms_invite_co_organizer_hint(inputs)
	if (locale === "bn") return bn_invite_co_organizer_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_co_organizer_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_co_organizer_hint(inputs)
	if (locale === "ur") return ur_invite_co_organizer_hint(inputs)
	if (locale === "fa") return fa_invite_co_organizer_hint(inputs)
	if (locale === "sw") return sw_invite_co_organizer_hint(inputs)
	if (locale === "nl") return nl_invite_co_organizer_hint(inputs)
	return en_invite_co_organizer_hint(inputs)
});